






























































import firebase from 'firebase/app'
import router, { Route } from 'vue-router'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import {
  getModule,
} from 'vuex-module-decorators'
import MainMixin from '../../mixins/MainMixin'
import QuickBar from './QuickBar.vue'
import UserStore from '../../store/modules/user'
import LocationStore from '../../store/modules/location'
import AppStore from '../../store/modules/app'

interface LinksType {
  title: string
  icon?: string
  link: string
  manager?: boolean
}

@Component({
  components: {
    QuickBar,
  },
})
export default class NavBar extends Mixins(MainMixin) {
  $vuetify: any

  name = 'NavBar'

  drawer = !this.$vuetify.breakpoint.xsOnly

  sidebar = false

  mUser = false

  title = 'Canvas Forms'

  get online () {
    return this.$store.getters.online
  }

  chooseLocation: boolean = false

  LocationStore = getModule(LocationStore)

  UserStore = getModule(UserStore)

  AppStore = getModule(AppStore)

  get location () {
    return this.$store.getters.location
  }

  get currentRoute () {
    console.log('route : ', router)
    return 'ok'
  }

  @Watch('$route')
  newRoute (nr: Route) {
    const titlesplit = nr.path.split('/')
    const foundTitle: string = (titlesplit[1] === 'management') ? titlesplit[2] : titlesplit[1]
    const page = this.allLinks.find(link => link.link === foundTitle)
    this.title = page && page.title ? page.title : 'Canvas Forms'
  }

  get allLinks () {
    return this.userLinks.concat(this.formLinks).concat(this.managerLinks)
  }

  userLinks: LinksType[] = [
    // { title: 'Messages', icon: 'mdi-message', link: 'messages' },
    { title: 'Coupons', icon: 'mdi-ticket-percent', link: 'coupons' },
    { title: 'Gift Certificates', icon: 'mdi-ticket-percent', link: 'giftcertificates' },
    { title: 'Tasks', icon: 'mdi-file-tree', link: 'tasks' },
    { title: 'Info Board', icon: 'mdi-information', link: 'information' },
    { title: 'Requests Off', icon: 'mdi-calendar', link: 'request-off' },
    { title: 'Settings', icon: 'mdi-cogs', link: 'settings' },
    // { title: 'Schedule', icon: 'mdi-calendar-multiple-check', link: 'schedule' },
  ]

  formLinks: LinksType[] = [
    { title: 'Incident Report', link: 'incident-report', manager: false },
    { title: 'Manager Report', link: 'manager-report', manager: true },
    { title: 'New Message', link: 'new-message', manager: false },
    { title: 'Server Report', link: 'server-report', manager: false },
    { title: 'Written Check', link: 'written-check', manager: false },
    // { title: 'Joker Draw', link: 'joker-draw', manager: false },
    { title: 'Contact Cards', link: 'contact-card', manager: false },
    { title: 'Comment Cards', link: 'comment-card', manager: false },
  ]

  managerLinks: LinksType[] = [
    // { title: 'Customers', link: 'customers' },
    { title: 'Display Boards', link: 'display-boards' },
    // { title: 'Email', link: 'email' },
    { title: 'Manage Coupons', link: 'manage-coupons' },
    { title: 'Manage Info Boards', link: 'manage-info-boards' },
    { title: 'Manange Requests Off', link: 'manage-requests-off' },
    // { title: 'Reports', link: 'reports' },
    { title: 'Setup Tasks', link: 'setup-tasks' },
    // { title: 'SMS', link: 'sms' },
    // { title: 'Submissions', link: 'submissions' },
    { title: 'Users', link: 'users' },
  ]

  logout () {
    this.$store.dispatch('removeOfflineRef')
    firebase.auth().signOut()
  }
}

